import React, {
  FC, useEffect,
} from 'react';
import { v4 as uuid } from 'uuid';
import { RowLeft } from '../Styles';
import { callService } from '../../../../../assets/base64Images/ai/callService';
import { updateFoodifoxData } from '../../../../../lib/axios/FoodifoxDataAPI';
import OptionButton from '../components/Button/OptionButton';
import { getCabId32Str, getWindowWidth, lang } from '../../../../../lib/utils/utils';
import LeftToRight from '../components/Animation/LeftToRight';
import RobotReply from '../components/Reply/RobotReply';
import { addSystemLog } from '../../../../../lib/SystemLogUtils';

/**
 * 电话联系客服
 */
const Q11: FC<Props> = ({
  cabId,
  addElement,
  deviceCode,
  h5Platform,
  sessionId,
}) => {
  const option = { zhValue: '重新开始', enValue: 'Restart' };

  const [saveCallLog] = updateFoodifoxData('/foxH5RentLog/saveCallServiceLog');

  useEffect(() => {
    // 流程ID
    const flowId = uuid();
    addElement(
      <LeftToRight flowId={flowId}>
        <RowLeft style={{ alignItems: 'center', marginTop: 25 }}>
          <RobotReply
            style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.58, getWindowWidth() * 0.58) }}
            langZh={(
              <>
                抱歉，出于安全考虑，我们需要匹配至少一样信息才可以为您打开柜门。如果需要额外帮助，可以拨打我们的人工服务热线 <span style={{ fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold' }}>1300 359 889</span> <span style={{ fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600 }}>（工作日早上9:00 至 下午5:00）</span>
              </>
            )}
            langEn={(
              <>
                Sorry, for security reasons I need to match at least one piece of information to open the door. Call our customer service hotline on <span style={{ fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold' }}>1300 359 889</span> Available <span style={{ fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold' }}>Weekdays 9:00am- 5:00pm</span>.
              </>
            )}
          />
          <img
            src={callService}
            style={{ width: 41, height: 41, marginLeft: 20 }}
            onClick={() => {
              addSystemLog(cabId, deviceCode, h5Platform + '', 'Q11 - user: call service', sessionId);
              location.href = 'tel:1300359889';
              saveCallLog({
                param: {
                  cabId: getCabId32Str(cabId),
                  telNumber: '1300359889',
                },
              });
            }}
          />
        </RowLeft>
      </LeftToRight>
    );

    // 机器人回复日志
    addSystemLog(cabId, deviceCode, h5Platform + '', 'Q11 - bot: I am sorry, for security reasons, we need to match at least one of above records to open the door for you.You can call us 1300 359 889 for human support between Weekdays 9:00am- 5:00pm', sessionId);

    setTimeout(() => {
      addElement(
        <LeftToRight flowId={flowId}>
          <RowLeft>
            <OptionButton
              langZh={option.zhValue}
              langEn={option.enValue}
              callback={() => {
                addSystemLog(cabId, deviceCode, h5Platform + '', 'Q11 - user: ' + option.enValue, sessionId);
                addElement([]);
              }}
            />
          </RowLeft>
        </LeftToRight>
      );
    }, 400);
  }, []);

  return (
    <></>
  );
};

export interface Props {
  cabId: number;
  addElement: (elements: any) => void;
  deviceCode: string;
  h5Platform: number;
  sessionId: string;
}

export default Q11;
